import { render, staticRenderFns } from "./MaintainPage.vue?vue&type=template&id=867dd528&scoped=true"
import script from "./MaintainPage.vue?vue&type=script&lang=js"
export * from "./MaintainPage.vue?vue&type=script&lang=js"
import style0 from "./MaintainPage.vue?vue&type=style&index=0&id=867dd528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867dd528",
  null
  
)

export default component.exports